export enum IdentityProvider {
  IdentityServer4 = 'IdentityServer4',
  Okta = 'Okta',
}

export interface IdentityClaims {
  customer_id?: string;
  sub?: string;
  iss?: string;
}

export interface GetIdentityProviderResponse {
  status: number;
  isSuccess: boolean;
  data: IdentityProvider;
}

export interface IAuthProvider {
  afterAuth(): Promise<void>;
  redirectToLogin(returnTo: string): Promise<void>;
  getAccessToken(): Promise<string>;
  silentRefresh(): Promise<boolean>;
  handleCallback(): Promise<string>;
  isAuthenticated(): Promise<boolean>;
  customerId: string | undefined;
  identityProvider: IdentityProvider;
}
